import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { makeSelectAppInited } from "../../app/appSelectors";
import { Loader } from "../../components/Loader/Loader";
import { useMemo } from "react";
import { AB_TESTS_LANDING_PAGE_OPTIONS, AB_TESTS_NAMES } from "../AbTests/abTestsConstants";
import WelcomePageContentRedesign from "./WelcomePageContentRedesign/WelcomePageContentRedesignLoadable";
import WelcomePageContentInitial from "./WelcomePageContentInitial/WelcomePageContentInitialLoadable";
import { WELCOME_PAGE_VERSION } from "./welcomeConstants";
import { useAbTestOption } from "../AbTests/abTestsHooks";

const WelcomePage = (props) => {
    const {inited, version} = props;
    const landingPageOption = useAbTestOption(AB_TESTS_NAMES.LANDING_PAGE);

    const ContentComponent = useMemo(() => {
        if (version === WELCOME_PAGE_VERSION.INITIAL || landingPageOption === AB_TESTS_LANDING_PAGE_OPTIONS.INITIAL) {
            return WelcomePageContentInitial
        } else {
            return WelcomePageContentRedesign
        }
    }, [landingPageOption, version])

    return (
        <>
            {
                !inited ? (
                    <Loader show/>
                ) : (
                    <ContentComponent/>
                )
            }
        </>
    );
};

const mapStateToProps = createStructuredSelector({
    inited: makeSelectAppInited(),
})

export default connect(mapStateToProps)(WelcomePage);
